var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationIcon3 = function SvgLocationIcon3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.668 5.8C.668 2.48 3.201.333 6.001.333c2.8 0 5.334 2.147 5.334 5.467 0 2.12-1.634 4.613-4.887 7.487a.678.678 0 0 1-.887 0C2.301 10.413.668 7.92.668 5.8Zm4-.133C4.668 6.4 5.268 7 6.001 7c.734 0 1.334-.6 1.334-1.333 0-.734-.6-1.334-1.334-1.334-.733 0-1.333.6-1.333 1.334Z",
    fill: "#000"
  })));
};
export default SvgLocationIcon3;